import React from 'react';
import PropTypes from 'prop-types';
import { Table, Message, Header } from 'semantic-ui-react';
import ListRowV2 from './ListRowV2';

const CancelledGuaranteePurchasesListV2 = ({ onSelectGuarantee, items }) => {
  const listRow = ListRowV2(onSelectGuarantee);

  if (!items || items.length === 0) {
    return (
      <div>
        <Header>Canceled Guarantee Purchases</Header>
        <Message info content='No data found.' />
      </div>
    );
  }

  const headerRow = (
    <Table.Row>
      <Table.HeaderCell>Buyer Email</Table.HeaderCell>
      <Table.HeaderCell>Auction Access#</Table.HeaderCell>
      <Table.HeaderCell>Dealer#</Table.HeaderCell>
      <Table.HeaderCell>VIN</Table.HeaderCell>
      <Table.HeaderCell>Universal#</Table.HeaderCell>
      <Table.HeaderCell>Days Selected</Table.HeaderCell>
      <Table.HeaderCell>Miles Selected</Table.HeaderCell>
      <Table.HeaderCell>If Bid?</Table.HeaderCell>
      <Table.HeaderCell>Seller Paid?</Table.HeaderCell>
      <Table.HeaderCell>Automatic Purchase?</Table.HeaderCell>
      <Table.HeaderCell>Vehicle Price</Table.HeaderCell>
      <Table.HeaderCell>Guarantee Price</Table.HeaderCell>
      <Table.HeaderCell>Status</Table.HeaderCell>
      <Table.HeaderCell>API Status</Table.HeaderCell>
      <Table.HeaderCell>Product</Table.HeaderCell>
      <Table.HeaderCell>Inspection Price</Table.HeaderCell>
      <Table.HeaderCell>Cancelling User Name</Table.HeaderCell>
      <Table.HeaderCell>Cancellation Date </Table.HeaderCell>
      <Table.HeaderCell>Cancellation Reason</Table.HeaderCell>
      <Table.HeaderCell />
    </Table.Row>
  );

  return (
    <div>
      <Header>Canceled Guarantee Purchases</Header>
      <div>
        <Table
          celled
          selectable
          padded
          renderBodyRow={listRow}
          tableData={items}
          headerRow={headerRow}
          size='small'
          striped
          compact='very'
          style={{ fontSize: '80%' }}
        />
      </div>
    </div>
  );
};

CancelledGuaranteePurchasesListV2.propTypes = {
  onSelectGuarantee: PropTypes.func.isRequired,
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default CancelledGuaranteePurchasesListV2;
